export const tableConfig = {
    filterable: true,
    className: '-striped',
    defaultPageSize: 10,
    previousText: '<',
    nextText: '>',
    loadingText: 'Cargando',
    noDataText: 'Sin datos',
    pageText: '',
    ofText: 'de',
    rowsText: 'registros',
    pageSizeOptions: [10, 20, 25, 50, 100],
};
